import { render, staticRenderFns } from "./Fund-Video.vue?vue&type=template&id=68e8d0cf&scoped=true&"
import script from "./Fund-Video.vue?vue&type=script&lang=js&"
export * from "./Fund-Video.vue?vue&type=script&lang=js&"
import style0 from "./Fund-Video.vue?vue&type=style&index=0&id=68e8d0cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e8d0cf",
  null
  
)

export default component.exports